import { getOnecomConfig } from "store/selectors";

// We need to group product impressions instead of pushing them
// separately, therefore we need to debounce the events while
// registerGTMEvent.productsImpression is triggered multiple times
// rapidly (e.g. multiple products visible at the same time):
const PRODUCTS_IMPRESSION_DELAY = 200;
let productsImpressionTimerId = null;
let allViewedProductsInLists = {};

const productsImpression = (newlyViewedProducts, { listName, listId }) => {
  return (dispatch, getState) => {
    let targetList = allViewedProductsInLists[listName];

    if (targetList) {
      // Extend the list of all viewed products, so we can
      // show viewed products grouped by display list instead
      // of pushing them separately when they appear in view:
      targetList.currentEventProducts.push(
        ...newlyViewedProducts.map((product, index) => ({
          ...product,
          index: index + targetList.countNextIndexFrom + 1, // +1 because index should be 1-based
        })),
      );

      // Also store the length of newly viewed products so we can count
      // item indexes properly from where we stopped in the last event:
      targetList.countNextIndexFrom += newlyViewedProducts.length;
    } else {
      // If there is no list yet with current list name, create a new
      // products group and index counter:
      targetList = {
        countNextIndexFrom: newlyViewedProducts.length,
        currentEventProducts: newlyViewedProducts.map((product, index) => ({
          ...product,
          index: index + 1, // +1 because index should be 1-based
        })),
      };
      allViewedProductsInLists[listName] = targetList;
    }

    // Debounce the actual GTM push to avoid spamming
    // multiple impression events when many products
    // become visible in quick succession.
    if (productsImpressionTimerId) {
      clearTimeout(productsImpressionTimerId);
    }

    productsImpressionTimerId = setTimeout(() => {
      const current = allViewedProductsInLists[listName];
      const products = current?.currentEventProducts;
      const { currency } = getOnecomConfig(getState()) || {};

      if (products && products.length) {
        // Always pass an array of products to GTM
        window.GTM.pushProductsImpression(products, {
          listName,
          listId,
          currency,
        });

        // Flush the products in the group without resetting
        // the index counter so only next impressions are
        // grouped while index counting continues:
        current.currentEventProducts = [];
      }

      productsImpressionTimerId = null;
    }, PRODUCTS_IMPRESSION_DELAY);
  };
};

export default productsImpression;
